import { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { RideStationType } from "@ryde/shared";

export interface IRidePassengersInOutIcon {
  statusType: RideStationType;
  isGreyed?: boolean;
}

export const RidePassengersInOutIcon: FC<IRidePassengersInOutIcon> = ({
  statusType,
  isGreyed,
}) => {
  return (
    <>
      {statusType === RideStationType.CatchRideOut && !isGreyed && (
        <SVG_MUI.PersonExitCatchRide4SVG />
      )}
      {statusType === RideStationType.CatchRideOut && isGreyed && (
        <SVG_MUI.PersonExitGreyedCatchRide4SVG />
      )}
      {statusType === RideStationType.CatchRideIn && !isGreyed && (
        <SVG_MUI.PersonEnterCatchRide4SVG />
      )}
      {statusType === RideStationType.CatchRideIn && isGreyed && (
        <SVG_MUI.PersonEnterGreyedCatchRide4SVG />
      )}
      {statusType === RideStationType.Out && !isGreyed && (
        <SVG_MUI.PersonExit4SVG />
      )}
      {statusType === RideStationType.Out && isGreyed && (
        <SVG_MUI.PersonExitGreyed4SVG />
      )}
      {statusType === RideStationType.In && !isGreyed && (
        <SVG_MUI.PersonEnter4SVG />
      )}
      {statusType === RideStationType.In && isGreyed && (
        <SVG_MUI.PersonEnterGreyed4SVG />
      )}
      {statusType === RideStationType.Both && !isGreyed && (
        <SVG_MUI.StopBlueRed3SVG />
      )}
      {statusType === RideStationType.Both && isGreyed && (
        <SVG_MUI.StopBlueRedGreyed3SVG />
      )}
    </>
  );
};
